import no from '~~/content/no/'
import dk from '~~/content/dk/'

export default function () {
  const locale = process.env.LOCALE || 'NO'

  if (locale === 'NO') return no
  else if (locale === 'DK') return dk
  else throw new Error(`FATAL ERROR: missing data for locale: ${locale}`)
}
